<template>
  <div>
    <v-checkbox
      v-if="!multiple"
      v-model="value"
      :label="label"
      :value="val"
      :error="error"
      v-bind="settings"
      v-on="$on"
      @input="updateValue"
      @change="updateValue"
    ></v-checkbox>

    <div v-if="multiple">
      <v-checkbox
        v-for="(option, index) in options"
        :key="index"
        v-model="value"
        :label="option.label"
        :value="option.value"
        :error="error"
        v-bind="settings"
        v-on="$on"
        @input="updateValue"
        @change="updateValue"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SGPFormCheckboxComponent',

  props: {
    options: {
      type: Array,
      required: false,
      default: () => []
    },

    label: {
      type: String,
      required: false
    },

    val: {
      type: String,
      required: false
    },

    value: {
      type: [Array, String, Boolean],
      required: true
    },

    error: {
      type: String
    },

    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
  },

  computed: {
    settings () {
      return {
        ...this.$attrs
      }
    }
  },

  methods: {
    updateValue () {
      this.$emit('input', this.value);
    }
  }
}
</script>